module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [_c('div', {
    staticClass: "white-background",
    staticStyle: {
      "position": "relative",
      "display": "flex",
      "flex-direction": "column",
      "height": "100%"
    },
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_c('ListList', {
    attrs: {
      "items": _vm.items
    },
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "5px",
      "bottom": "10px",
      "width": "60px"
    }
  }, [_c('v-btn', {
    attrs: {
      "right": "",
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "large": ""
    }
  }, [_vm._v("mdi-plus")])], 1)], 1)], 1), _vm._v(" "), (_vm.item) ? _c('div', {
    staticClass: "pa-10 white ma-7 elevation-3",
    staticStyle: {
      "position": "relative",
      "xbackground-color": "rgba(0,0,0,0.0)"
    }
  }, [_c('ConfirmIcon', {
    attrs: {
      "corner": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteCurrent()
      }
    }
  }), _vm._v(" "), _c('FormControl', {
    ref: "itemForm",
    attrs: {
      "schema": _vm.proofSchema
    },
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2398737a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dc/Maintenance.vue
// module id = 2483
// module chunks = 1